import { Loader } from "@logora/debate.progress.loader";
import { BillBox } from "@logora/parliament.bill.bill_box";
import { Box as UiBox } from "@logora/parliament.ui.box";
import { VoteBox } from "@logora/parliament.vote.vote_box";
import React, { useState, useEffect, useCallback } from "react";
import { useAuthenticated, useDataProvider } from "react-admin";
import { useNavigate } from "react-router-dom";
import { SearchBar } from "../search/SearchBar";
import { formatType } from "../datasets/scrutins";
import logo from "../../images/legiwatch_dark.png";
import styles from "./Dashboard.module.scss";

export const Dashboard = () => {
	const [dossiersLoading, setDossiersLoading] = useState(true);
	const [votesLoading, setVotesLoading] = useState(true);
	const [lastDossiers, setLastDossiers] = useState([]);
	const [lastVotes, setLastVotes] = useState([]);
	const dataProvider = useDataProvider();
	const navigate = useNavigate();
	useAuthenticated();

	useEffect(() => {
		fetchLastDossiers();
		fetchLastVotes();
	}, []);

	const fetchLastDossiers = useCallback(async () => {
		try {
			const response = await dataProvider.getList("dossiers", {
				filter: {},
				include: [
					"acteurPrincipalRef.groupeParlementaire",
					"documentDeposeRef.auteurPrincipal.groupeParlementaire",
					// "commissionANRef",
					// "commissionSNRef",
					// "rapporteurs.acteurRef.groupeParlementaire",
				],
				sort: { field: "dateDepot", order: "desc" },
				pagination: { page: 1, perPage: 12 },
			});
			const lastDossiers = response.data;
			if (lastDossiers) {
				setLastDossiers(lastDossiers);
			}
			setDossiersLoading(false);
		} catch (error) {
			console.log(error);
			setDossiersLoading(false);
		}
	}, [dataProvider]);

	const fetchLastVotes = useCallback(async () => {
		try {
			const response = await dataProvider.getList("scrutins", {
				filter: {},
				include: [],
				sort: { field: "dateScrutin", order: "desc" },
				pagination: { page: 1, perPage: 16 },
			});
			const lastVotes = response.data;
			if (lastVotes) {
				setLastVotes(lastVotes);
			}
			setVotesLoading(false);
		} catch (error) {
			console.log(error);
			setVotesLoading(false);
		}
	}, [dataProvider]);

	return (
		<div className={styles.dashboard}>
			<div className={styles.searchSection}>
				<h1 className={styles.searchHeadline}>
					<img src={logo} width={300} alt="Logo Legiwatch" />
				</h1>
				<div className={styles.searchContainer}>
					<SearchBar
						onSearchChange={(search) =>
							navigate(`/parliament/dossiers/?query=${search}`)
						}
						placeholder={
							"Rechercher un sujet, un parlementaire avec @, un groupe avec /..."
						}
						onUpdateGlobalFilters={() => null}
						updateSearchParams={false}
						disableSyncWithLocation
					/>
				</div>
				<p className={styles.searchText}>
					Trouvez des informations sur les dossiers législatifs, les
					parlementaires et les votes
				</p>
			</div>
			<div>
				<UiBox
					title="Derniers dossiers"
					visibleCount={3}
					className={styles.listContainer}
					childBorder={false}
				>
					{!dossiersLoading ? (
						lastDossiers.map((dossier) => {
							return (
								<BillBox
									key={dossier.uid}
									resource={dossier}
									className={styles.contentBox}
									hideStatus
								/>
							);
						})
					) : (
						<Loader />
					)}
				</UiBox>
			</div>
			<div>
				<UiBox
					title="Derniers votes"
					visibleCount={4}
					className={styles.listContainer}
					childBorder={false}
				>
					{!votesLoading ? (
						lastVotes.map((vote) => {
							return (
								<VoteBox
									key={vote.uid}
									voteUid={vote.uid}
									date={vote.dateScrutin}
									mainText={vote.titre}
									status={vote.code}
									type={formatType(vote)}
									statusHighlighted
									className={`${styles.contentBox} ${styles.voteBox}`}
								/>
							);
						})
					) : (
						<Loader />
					)}
				</UiBox>
			</div>
		</div>
	);
};
